/* eslint-disable max-len */

export const DEACTIVATED_INFO =
  'The employee has been deactivated from the Vault App. They are still able to log in to the Vault App on their device, but cannot submit new reports, message with a case manager, or receive status updates to previously submitted reports.';

export const EXPIRING_INFO =
  'The employee has been flagged for deactivation. The employee will be deactivated from the Vault App at the end of the expiration period, which has been set by your company. Expiring employees still have full access to the Vault App until their deactivation date.';

export const INVITED_INFO =
  'This individual has been added to Vault, and has been sent an invite email to the reporting apps. To re-invite them, select the checkbox next to this users name and press the Send reporting invite button at the top of the page.';

export const INVITED_INFO_SLACK =
  'This individual has been added to Vault, and has been sent an invite email to Slack reporting. To re-invite them, select the checkbox next to this users name and press the Send reporting invite button at the top of the page.';

export const NOT_INVITED_INFO =
  'This individual has been added to Vault, but has not been sent an invite email to the reporting apps.';

export const NOT_INVITED_INFO_SLACK =
  'This individual has been added to Vault, but has not been sent an invite email to Slack reporting';
